module.exports = __webpack_public_path__ + "img/book@2x.b12b31bd.png";